<template>
  <v-container fluid class="SpecificGroup-mainContainer"> <!-- uso de clases css class="componente-nombreClase"-->
    <v-row v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
        <v-col md="2" class="smartbell-smartbellLeftSideDesktop" v-if="userData.onboarding === true">
        </v-col>
        <v-col md="10" offset-md="2" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
            <v-row>
                <v-col md="4" class="DashCow-cowButton">
                    <v-btn class="SpecificGroup-controlButton smartbell-buttonCorrection"><img src="../assets/BotonRegresar.png" alt="" @click="routerGoBackOne()"></v-btn>
                </v-col>
                <v-col md="4" offset-md="4" style="text-align:end;" class="DashCow-cowNumber">
                    <span class="DashCow-cowNumberLeft">Vacas en sistema</span><span class="DashCow-cowNumberRight">{{animalsNumber}}</span>
                </v-col>
            </v-row>
            <v-row align="center" justify="center">
                <v-col md="12" class="SpecificGroup-mainCard">
                    <v-card class="SpecificGroup-groupData">
                        <v-toolbar dark color="#1460AA">
                            <v-toolbar-title class="SpecificGroup-groupTitle"><input type="text" v-model="groupName"><img src="../assets/Pencil.png" alt=""></v-toolbar-title>
                        </v-toolbar>
                        <v-row class="SpecificGroup-noPadding">
                            <v-col md="12" class="SpecificGroup-noPadding">
                                <v-col md="12" class="Home-centered SpecificGroup-noPadding">
                                    <v-row class="SpecificGroup-cowListPadding SpecificGroup-noPadding SpecificGroup-cowsGroup">
                                        <v-col md="4" offset-md="8" class="SpecificGroup-noPadding SpecificGroup-cowGroupCol">
                                            <span class="DashCow-cowNumberLeft SpecificGroup-cowsGroupLeft">Vacas en potrero</span><span class="DashCow-cowNumberRight SpecificGroup-cowsGroupRight">{{ formattedAnimalsNumber }}</span>
                                        </v-col>
                                    </v-row>
                                   <v-row class="SpecificGroup-cowListPadding SpecificGroup-noPadding">
                                    <v-col md="8" class="SpecificGroup-noPadding">
                                        <v-text-field
                                            outlined
                                            label="Descripción"
                                            :placeholder="groupDescription"
                                            v-model="groupDescription"
                                        ></v-text-field>
                                    </v-col>
                                        <v-col md="4" class="SpecificGroup-noPadding">
                                            <v-btn class="smartbell-greenButton SpecificGroup-groupAddGroup SpecificGroup-addCowsGroup smartbell-buttonCorrection">
                                                Agregar Vacas a Potrero
                                                <img src="../assets/adultCow.png" alt="" style="margin-left:4%; color:#fff;">
                                            </v-btn>
                                        </v-col>
                                   </v-row>
                                   <v-row class="SpecificGroup-cowListPadding SpecificGroup-noPadding">
                                        <v-col md="3" class="SpecificGroup-noPadding">
                                            <v-text-field
                                                outlined
                                                label="Buscar vaca por ID"
                                                placeholder="ID vaca"
                                                append-icon="search"
                                                v-model="searchBar"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col md="3" offset-md="2" class="SpecificGroup-noPadding">
                                                <v-select
                                                    :items="firstFilterOptions"
                                                    label="Filtros disponibles"
                                                    v-model="firstFilterSelected"
                                                    placeholder="Categoría"
                                                    outlined
                                                ></v-select>
                                        </v-col>
                                        <v-col md="4" class="SpecificGroup-noPadding">
                                            <v-select
                                                :items="secondFilterOptions"
                                                :placeholder="selectedPlaceHolder"
                                                v-model="secondFilterSelected"
                                                :disabled="secondFilterDisabled"
                                                outlined
                                            ></v-select>
                                        </v-col>
                                   </v-row>
                                   <v-row style="padding: 28px; padding-top:0; padding-bottom:0;" class="DashCow-titleListContainer">
                                        <v-col md="2" cols="3" class="DashCow-titleList DashCow-titleListFirst">
                                            <span>ID vaca</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                                        </v-col>
                                        <v-col md="2" cols="3" class="DashCow-titleList">
                                            <span>Raza</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                                        </v-col>
                                        <v-col md="2" cols="3" class="DashCow-titleList">
                                            <span>Estado</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                                        </v-col>
                                        <v-col md="2" cols="3" class="DashCow-titleList">
                                            <span>DIM</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                                        </v-col>
                                        <v-col md="2" cols="3" class="DashCow-titleList">
                                            <span>Grupo</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                                        </v-col>
                                        <v-col md="2" cols="3" class="DashCow-titleList DashCow-titleListLast">
                                            <span>Acciones</span> <img src="../assets/arrowTwo.svg" alt="" class="DashCow-arrowTwo"><img src="../assets/arrowOne.svg" alt="">
                                        </v-col>
                                    </v-row>
                                    <div class="SpecififGroup-allCowList">
                                        <v-row style="padding: 28px; padding-top:0; padding-bottom:0" class="DashCow-cowListContainer" v-for="(cow, index) in filteredAnimalsInGroup" :key="cow.id">
                                            <v-col md="2" cols="3" class="DashCow-cowList DashCow-cowListFirst">
                                                <img src="../assets/Vacaadulta.svg" alt=""> <span>{{cow.id}}</span>
                                            </v-col>
                                            <v-col md="2" cols="3" class="DashCow-cowList">
                                                <span>{{cow.breed}}</span>
                                            </v-col>
                                            <v-col md="2" cols="3" class="DashCow-cowList">
                                                <span>{{cow.milkState}}</span>
                                            </v-col>
                                            <v-col md="2" cols="3" class="DashCow-cowList">
                                                <span>{{cow.dim}}</span>
                                            </v-col>
                                            <v-col md="2" cols="3" class="DashCow-cowList">
                                                <span>{{ groupName }}</span>
                                            </v-col>
                                            <v-col md="2" cols="3" class="DashCow-cowList DashCow-cowListLast">
                                              <v-icon class="DashCow-cowListAction">edit</v-icon>
                                              <v-icon @click="deleteCow(index)" class="DashCow-cowListAction">delete</v-icon>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-col>
                        </v-row>
                    </v-card>
                  <!-- Guardar potrero -->
                  <v-row class="SpecificGroup-cowListPadding SpecificGroup-noPadding">
                    <v-col md="3" class="SpecificGroup-noPadding SpecificGroup-deleteGroupCol">
                      <v-btn @click="changeGroupName()" class="smartbell-blueLigthButton smartbell-buttonCorrection">
                        <v-icon class="DashCow-cowListAction">save</v-icon>
                        Guardar potrero
                      </v-btn>

                    </v-col>
                    <v-col md="3" class="SpecificGroup-noPadding SpecificGroup-deleteGroupCol">
                        <v-btn class="smartbell-blueLigthButton smartbell-buttonCorrection">
                            <v-icon class="DashCow-cowListAction" @click="deleteGroup()">delete</v-icon>
                            Eliminar potrero
                        </v-btn>
                    </v-col>
                    <v-col md="3" class="SpecificGroup-noPadding SpecificGroup-deleteGroupCol">
                      <v-btn class="smartbell-blueLigthButton smartbell-buttonCorrection" @click="processingData()">
                        <v-icon class="DashCow-cowListAction"></v-icon>Processing DB
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NavBar from '@/views/NavBar.vue'
import axios from 'axios'
export default {
  name: 'SpecificGroup',
    data () {
      return {
          firstFilterOptions:['Raza', 'Estado', 'Ninguno'],
          firstFilterSelected: '',
          secondFilterOptions: [],
          secondFilterSelected: '',
          selectedPlaceHolder: '',
          secondFilterDisabled: true,
          mailActive: true,
          smsActive: false,
          webActive: false,
          notificationActive: false,
          currentCowsToShow: [], // vacas que se mostrarán en el grupo individual
          searchBar: '', // texto de búsqueda por ID
          lastCowFlag: this.$store.getters.getAnimals.filter(cow => cow.group === this.$store.getters.getGroup.name).length === 1, // flag que indica si se trata de la última vaca del grupo
          groupName: this.$store.getters.getGroup.name, // el nombre del grupo
          groupDescription: this.$store.getters.getGroup.description, // la descripción del grupo
      }
  },
  components: {
      NavBar
  },
    watch: {
      /**
       * Observa los cambios en searchBar para modificar los animales a mostrar
       * @param someID el nuevo ID a buscar
       */
      searchBar(someID) {
          const animalsInGroup = this.$store.getters.getAnimals.filter(cow => cow.group === this.groupName);
          if (someID === '') {
              this.setCowsToShow(animalsInGroup);
          } else {
              const foundCows = animalsInGroup.filter(cow => cow.id.toLowerCase().includes(someID.toLowerCase()));
              this.setCowsToShow(foundCows);
          }
          return null;
      },
        /**
         * Revisa los cambios en el número de las vacas presentes en el grupo
         */
        cowsInGroup(newNumber) {
          this.lastCowFlag = newNumber === 1;
        },
        firstFilterSelected() {
            this.setCowsToShow(this.cowsInGroup);
            switch (this.firstFilterSelected) {
                case 'Raza':
                    this.secondFilterDisabled = false;
                    this.secondFilterOptions = this.breedsInGroup;
                    break;
                case 'Estado':
                    this.secondFilterDisabled = false;
                    this.secondFilterOptions = ['Seca', 'Lactando'];
                    break;
                case 'Ninguno':
                    this.secondFilterDisabled = true;
                    this.secondFilterOptions = [];
                    break;
                default:
                    this.secondFilterDisabled = true;
                    this.secondFilterOptions = [];
            }
        },
        secondFilterSelected(newFilter) {
            const animalsInGroup = this.$store.getters.getAnimals.filter(cow => cow.group === this.groupName);
            switch (this.firstFilterSelected) {
              case 'Raza':
                  if (newFilter !== '') {
                      console.log('holi');
                      console.log(newFilter);
                      this.setCowsToShow(animalsInGroup.filter(cow => cow.breed === newFilter));
                  }
                  break;
              case 'Estado':
                  if (newFilter !== '') {
                      this.setCowsToShow(animalsInGroup.filter(cow => cow.milkState === newFilter));
                  }
                  break;
              default:
                  this.setCowsToShow(animalsInGroup);
                  break;
          }
        },
    },
  computed: {
      /**
       * Regresa las razas de los animales en el grupo
       */
      breedsInGroup() {
          let tempBreeds = [];
          this.cowsInGroup.forEach(cow => {
              if (tempBreeds.indexOf(cow.breed) === -1) {
                  tempBreeds.push(cow.breed);
              }
          });
          return tempBreeds;
      },
      /**
       * Regresa el grupo seleccionado por el usuario
       */
      selectedGroup() {
          return this.$store.getters.getGroup;
      },
      /**
       * Regresa todos los animales en el grupo
       * @returns {*}
       */
      filteredAnimalsInGroup: {
          get() {
              return this.$store.getters.animalsInGroup;
          },
          set(newValue) {
              this.$store.commit('changeAnimalsInGroup', newValue);
          }
      },
      /**
       * Regresa el número de animales en el sistema actual
       * @returns {string}
       */
      formattedAnimalsNumber() {
          let formattedAnimalsNumber = '';
          let tempAnimalsNumber = this.$store.getters.getAnimals.filter(cow => cow.group === this.$store.getters.getGroup.name).length;
          if (tempAnimalsNumber < 10) {
              formattedAnimalsNumber = "00" + tempAnimalsNumber;
          } else if (tempAnimalsNumber < 100) {
              formattedAnimalsNumber = "0" + tempAnimalsNumber;
          } else if (tempAnimalsNumber < 1000) {
              formattedAnimalsNumber = tempAnimalsNumber;
          }
          return formattedAnimalsNumber;
      },
      /**
       * Regresa todas las vacas en el sistema que tengan este grupo
       */
      numberOfCowsInGroup() {
          return this.$store.getters.getAnimals.filter(cow => cow.group === this.$store.getters.getGroup.name).length;
      },
      cowsInGroup() {
          return this.$store.getters.getAnimals.filter(cow => cow.group === this.$store.getters.getGroup.name);
      },
      animalsNumber() {
          return this.$store.getters.getAnimalsNumber;
      },
      /**
       * Regresa la información del usuario
       * @returns {actions.getUserData|getters.getUserData}
       */
      userData() {
          return this.$store.getters.getUserData;
      },
  },
  methods: {
      routerGoBackOne(){
          this.$router.go(-1)
      },
      /**
       * Permite borrar una vaca individualmente del sistema y en caso
       * de que sea la última vaca, entonces borra en su totalidad el grupo
       * @param index el índice de la vaca a eliminar
       */
      deleteCow(index) {
          if (this.lastCowFlag) {
              console.log('Última vaca, vamos a borrar el grupo. No regrets.');
              this.deleteGroup();
          } else {
              const data = {
                  cowKey: this.filteredAnimalsInGroup[index].key,
                  groupName: 'Establo general',
                  numberOfCows: this.filteredAnimalsInGroup.length - 1,
              };
              this.$store.dispatch('changeCowGroup', data);
          }
      },
      deleteGroup() {
          let data = {
              key: this.$store.getters.getGroup.key,
              cows: this.$store.getters.getAnimals.filter(cow => cow.group === this.$store.getters.getGroup.name),
          };
          this.$store.dispatch('deleteGroup', data);
          this.routerGoBackOne();
      },
      /**
       * Regresa todas las vacas en el grupo que sean visibles para el usuario
       * @param cows las vacas a mostrar para el usuario
       */
      setCowsToShow(cows) {
          this.filteredAnimalsInGroup = cows;
      },
      changeGroupName() {
          const newGroup = {
              name: this.groupName,
              cows: this.$store.getters.getAnimals.filter(cow => cow.group === this.$store.getters.getGroup.name),
              description: this.groupDescription,
          };
          // cambia el grupo de las vacas en firebase, además de recargar el array del grupo actual
          this.$store.dispatch('changeFireCowsGroup', newGroup);
          // cambia el nombre del grupo seleccionado directamente del estado
          this.$store.commit('changeSelectedGroupName', this.groupName);
          // cambia el nombre del grupo en firebase
          this.$store.dispatch('changeFireGroupName', newGroup);
      },
      processingData() {
          axios.get('http://localhost:8080/smartbell-master-export.json').then(response => {
              const database = response.data;
              let users = database.users;
              for (let key in users) {
                  let user = users[key];
                  let counterRegister = 0;
                  let counterHistory = 0;
                  let counterSick = 0;
                  let counterGestation = 0;
                  let counterHeat = 0;
                  let history = [];
                  let objectPaddocks = user['ranchos'];
                  for (let indexPaddock in objectPaddocks) {
                      let paddock = objectPaddocks[indexPaddock];
                      let objectCow = paddock['vacas'];
                      if (typeof objectCow !== 'undefined') {
                          let userCowCounter = 0;
                          for (let indexCow in objectCow) {
                              let cow = objectCow[indexCow];
                              let objectRegister = cow['currentRegister'];
                              let objectHistory = cow['history'];
                              userCowCounter++;
                              counterRegister = 0;
                              for (let indexRegister in objectRegister) {
                                  if (objectRegister[indexRegister].isConfirm){
                                      counterRegister++;
                                  }
                              }
                              if (typeof objectHistory  !== 'undefined') {
                                  for (let indexHistory in objectHistory) {
                                      let event = objectHistory[indexHistory];
                                      history.push(event);
                                      if (event.type === 'sick') {
                                          counterSick++
                                      } else if (event.type === 'gestation') {
                                          counterGestation++;
                                      } else {
                                          counterSick++;
                                      }
                                      counterHistory++;
                                  }
                              }
                          }
                          console.log(user.firstName + ' ' + user.lastName + ' con ' + userCowCounter + ' vacas e ' + counterRegister + ' interacciones actuales');
                          console.log('Reportadas ' + counterHistory + ' en el historial de cada animal.');
                          console.log('Aquí están las interacciones ->');
                          console.log('Enfermedad: ' + counterSick);
                          console.log('Gestación: ' + counterGestation);
                          console.log('Celo: ' + counterHeat + '\n');
                          console.log('');
                      }
                  }
              }
          });
      }
  },
  mounted() {
  }
};
</script>

<style lang="css">
  @import '../style/SpecificGroup.css';
</style>
